import { FC, useEffect } from 'react';
import { MainSection } from './features/MainSection/MainSection';
import { Contacts } from './components/Contacts/Contacts';
import { Footer } from './components/Footer/Footer';

const App: FC = () => {
  useEffect(() => {
    document.title = 'Glass Moon';
  }, []);

  return (
    <>
      <MainSection />
      <Contacts />
      <Footer />
    </>
  );
}

export default App;
